export function NotFoundPage(): React.JSX.Element {
  return (
    <section className="card" data-testid="not-found-page">
      <h2>Page not found</h2>
      <p>That address is not part of InventoHub.</p>
    </section>
  );
}
